const getNextDeliveryDates = async (future_weeks) => {
  try {
    if (!Number.isInteger(future_weeks)) {
      throw new Error("future_weeks must be an integer");
    }
    const future_days = future_weeks * 7;
    const session = localStorage.getItem("meal-plan-session");
    const mealPlanSession = JSON.parse(session);
    const starting_date = new Date(mealPlanSession.delivery_info.starting_date);
    const next_available_dates = {
      "twice-week": [],
      wednesday: [],
      sunday: [],
    };

    let how_many_mondays_between_dates = 0;
    for (let i = 0; i < future_days; i++) {
      const next_day_milliseconds = 1000 * 60 * 60 * 24 * i;
      const next_day = new Date(
        starting_date.getTime() + next_day_milliseconds
      );
      const difference_in_days =
        (next_day.getTime() - starting_date.getTime()) / (1000 * 3600 * 24);

      const week_day = next_day
        .toLocaleDateString("en-CA", { weekday: "long" })
        .toLowerCase();

      if (week_day == "monday") {
        how_many_mondays_between_dates += 1;
      }
      const correspondent_weekly_menu =
        mealPlanSession.delivery_info.frequency == "twice-week"
          ? difference_in_days >= 6
            ? week_day === "wednesday"
              ? checkCorrespondentWeeklyMenu(how_many_mondays_between_dates - 1)
              : checkCorrespondentWeeklyMenu(how_many_mondays_between_dates)
            : window.current_week_menu
          : checkCorrespondentWeeklyMenu(how_many_mondays_between_dates);

      if (week_day == "wednesday" || week_day == "sunday") {
        next_available_dates[week_day].push({
          timestamp: next_day.getTime(),
          menu_week: correspondent_weekly_menu,
        });
        next_available_dates["twice-week"].push({
          timestamp: next_day.getTime(),
          menu_week: correspondent_weekly_menu,
        });
      }
    }
    if (mealPlanSession.delivery_info.frequency == "twice-week") {
      return next_available_dates["twice-week"];
    } else {
      return next_available_dates[mealPlanSession.delivery_info.delivery_day];
    }
  } catch (e) {
    console.error("ERROR: Could not get next delivery dates");
  }
};

const populateWrapper = async (wrapper, number_of_weeks = 8) => {
  const selector = document.querySelector(`${wrapper}`);
  selector.innerHTML = skeletonReview();
  if (selector) {
    const delivery_calendar = await getNextDeliveryDates(number_of_weeks);

    const repeatedWeeks = {};
    delivery_calendar.forEach((item) => {
      if (repeatedWeeks[item.menu_week] === undefined) {
        repeatedWeeks[item.menu_week] = 1;
      } else {
        repeatedWeeks[item.menu_week] += 1;
      }
    });
    const futureMenu = await buildFutureMenu(8);

    const weekly_menu = futureMenu.length > 1 ? [] : futureMenu;

    if (weekly_menu.length == 0) {
      for (const item in repeatedWeeks) {
        const times = repeatedWeeks[item];
        const WEEK_INDEX = futureMenu.findIndex((i) => i.week === item);
        if (WEEK_INDEX !== -1) { // Verifica se o índice é válido
          const week = futureMenu[WEEK_INDEX];
          for (let i = 1; i <= times; i++) {
            weekly_menu.push(week);
          }
        }
      }
    }

    sortWeeks(weekly_menu);

    const dates_navigation = `
    <div class="dates-navigation-wrapper">
        <div id="weeklyMenuNavigation" class="splide">
          <div class="splide__track">
            <ul class="dates-navigation splide__list">
                ${delivery_calendar
        .map((item, index) => {
          const date = new Date(item.timestamp);
          return `
                    <li class="splide__slide">
                      <button
                        delivery-date="${item.timestamp}"
                        menu-week=${item.menu_week}
                      >
                      <span class="week-day">${date
              .toLocaleString("default", {
                weekday: "short",
              })
              .toUpperCase()} ${" "}</span> 
                      <span>${Number(
                date.getMonth() + 1
              )}/${date.getDate()}</span>
                      </button>
                    </li>
                    `;
        })
        .join("")}
                <li class="splide__slide">
                  <button
                    delivery-date="Learn more"
                    menu-week="learn-more"
                    style="font-size:10px; text-align: left;"
                  >
                  <span>LEARN MORE</span>
                  </button>
                </li>
            </ul>
          </div>
        </div>
    </div>
   `;

    console.log({ weekly_menu });
    const week_menu = `
    <div class="weekly-menu splide">
      <div class="week-menu-wrapper splide__track">
          <ul class="week-menu splide__list">
            ${weekly_menu
        .filter(week => week && typeof week === 'object' && week.week) // Filtra elementos válidos
        .map((week, WEEK_INDEX) => {
          const week_number = week.week;
          return `
                <li class="splide__slide" week-number="${week_number}" data-is-a-similar-product="${WEEK_INDEX == 0 ? false : true}">
                  ${week.list
              .map((product, PROD_INDEX) => {
                const isFirstDelivery = WEEK_INDEX == 0;
                const isFirstRow = PROD_INDEX == 0;
                const description =
                  product.category == "meals"
                    ? parseDescription(product.description)
                    : "";
                product.title =
                  product.title.indexOf("Meal Box") > -1
                    ? product.title.split(" - ")[2]
                    : product.title;
                const price =
                  product.price?.standard * 100 * 0.95 ||
                  product.price * 0.95;
                const product_img = product.images[0] ? `${product.images[0]}&width=58` : "https://cdn.shopify.com/s/files/1/0531/4596/0627/files/default-product-image.webp?v=1679933323"
                return `
                      <div class="review-line-item-container">
                      ${isFirstRow
                    ? isFirstDelivery
                      ? `<div class="first-delivery">FIRST DELIVERY</div>`
                      : `<div class="upcoming-delivery">
                                  UPCOMING DELIVERY
                                  <small>YOU WILL BE ABLE TO MODIFY ANY FUTURE DELIVERIES FROM OUR SUBSCRIPTION PORTAL</small>
                                </div>`
                    : ""
                  }
                        <div class="review-line-item">
                          <div class="review-line-item__image" data-product-info-popup="${product.id
                  }">
                            <img
                              loading="lazy"
                              width="58"
                              height="58"
                              src="${product_img}"
                              alt="${product.title}"
                            >
                          </div>
                          <div class="review-line-item__center">
                            <h3 class="title" data-product-info-popup="${product.id
                  }">${product.title}</h3>
                            <div class="product-desc">
                              <p class="description">${description !== undefined ? description : ""
                  }</p>
                            </div>
                            <button class="more-info" data-product-info-popup="${product.id
                  }">view macros</button>
                          </div>
                          <div class="review-line-item__right">
                            <p>$${currencyFormatter(price)}</p>
                            <div class="qty-selector-wrapper ${isFirstDelivery ? "" : "hide"
                  }">
                              <div class="qty-selector">
                                ${product.default_qty
                    ? `<button class="qty-minus">-</button>
                                <input
                                  readonly
                                  type="number"
                                  value="${product.default_qty}"
                                  min="0" max="30"
                                  class="qty-input"
                                  data-product-id="${product.id}"
                                  data-product-category="${product.category}"
                                >
                                <button class="qty-plus">+</button>`
                    : ""
                  }
                                
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      `;
              })
              .join("")}
                  </li>`;
        })
        .join("")}
              <li class="splide__slide" week-number="learn-more">
                <div class="review-line-item-container">
                <div class="delivery-info upcoming-delivery">ROTATING MENU</div>
                  <p>
                    Power Kitchen has a rotating menu that uses fresh, local
                    and in-season produce for the best quality ingredients in
                    each meal.
                    <br>Keep checking our website to find out which will
                    be your meals for the next weeks.
                  </p>
                  <img
                    src="https://cdn.shopify.com/s/files/1/0531/4596/0627/files/PK_home_cook_animation5_1.gif?v=1662472846&width=300"
                    width="150"
                    height="150"
                    alt="Cooking"
                  >
                </div>
              </li>
          </ul>
      </div>
    </div>
   `;
    const container = `
    <div class="weekly-menu-container">
        ${dates_navigation}
        ${week_menu}
    </div>
    `;
    selector.innerHTML = container;
    const main = new Splide(".weekly-menu.splide", {
      type: "slide",
      fixedHeight: "fit-content",
      pagination: false,
      arrows: false,
      rewind: false,
    });
    const thumbnails = new Splide("#weeklyMenuNavigation", {
      pagination: false,
      fixedWidth: "100%",
      gap: "24px",
      isNavigation: true,
      focus: "center",
      arrows: true,
      rewind: false,
      dragMinThreshold: {
        mouse: 0,
        touch: 1,
      },
    });
    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
    window.meal_plan_functions.infoButtonsListers();
    window.meal_plan_functions["getFutureMenuData"] = () => {
      const list = [];
      futureMenu.forEach((week) => {
        week.list.forEach((item) => {
          list.push(item);
        });
      });
      return list;
    };
  }
};

const buildFutureMenu = async (number_of_weeks) => {
  const session = localStorage.getItem("meal-plan-session");
  const mealPlanSession = JSON.parse(session);
  const initial_meals = mealPlanSession.initial_meals;
  const initial_breakfast = mealPlanSession.initial_breakfast || [];
  const initial_snacks = mealPlanSession.initial_snacks || [];
  const initial_basket = [
    ...initial_meals,
    ...initial_breakfast,
    ...initial_snacks,
  ];
  try {
    const futureMenu = await getSimilarProduct(initial_basket, number_of_weeks);

    if (futureMenu == undefined) {
      throw new Error("Not possible to build future menu");
    }

    futureMenu[current_week_menu] = initial_basket.map((product) => {
      const macros = [];
      product.json.tags.forEach((tag) => {
        if (tag.includes("nutri-cals")) {
          const macro_obj = {
            name: "Calories",
            value: tag.replace("nutri-cals:", ""),
          };
          macros.push(macro_obj);
        } else if (tag.includes("nutri-carbs")) {
          const macro_obj = {
            name: "Carbs",
            value: tag.replace("nutri-carbs:", ""),
          };
          macros.push(macro_obj);
        } else if (tag.includes("nutri-fats")) {
          const macro_obj = {
            name: "Fats",
            value: tag.replace("nutri-fats:", ""),
          };
          macros.push(macro_obj);
        } else if (tag.includes("nutri-proteins")) {
          const macro_obj = {
            name: "Proteins",
            value: tag.replace("nutri-proteins:", ""),
          };
          macros.push(macro_obj);
        }
      });
      return {
        ...product.json,
        category: product.category,
        description: product.json.description,
        macros,
        initial: true,
        default_qty: product.qty,
      };
    });
    const array = [];
    for (const item in futureMenu) {
      array.push({ week: item, list: futureMenu[item] });
    }
    return sortWeeks(array);
  } catch (e) {
    console.error(e);
    const returnOnlyCurrentWeekProducts = initial_basket.map((p) => {
      return p.json;
    });
    return [
      {
        week: current_week_menu,
        list: [...returnOnlyCurrentWeekProducts],
      },
    ];
  }
};

const checkCorrespondentWeeklyMenu = (number_of_mondays) => {
  const remainer =
    (current_week_menu + number_of_mondays) % 8 == 0
      ? 8
      : (current_week_menu + number_of_mondays) % 8;
  return remainer;
};

const sortWeeks = (arr) => {
  arr.sort((a, b) => {
    if (parseInt(a.week) <= parseInt(window.current_week_menu)) {
      return -1;
    }
    if (parseInt(b.week) < parseInt(window.current_week_menu)) {
      return -1;
    }
  });
  return arr;
};

const skeletonReview = () => {
  return `<div class="skeleton-container">
  <div class="skeleton-thumb"></div>
  <div class="skeleton-wrapper">
    <div class="skeleton-line"></div>
    <div class="skeleton-line"></div>
  </div>
</div>
<div class="skeleton-container">
  <div class="skeleton-thumb"></div>
  <div class="skeleton-wrapper">
    <div class="skeleton-line"></div>
    <div class="skeleton-line"></div>
  </div>
</div>
<div class="skeleton-container">
  <div class="skeleton-thumb"></div>
  <div class="skeleton-wrapper">
    <div class="skeleton-line"></div>
    <div class="skeleton-line"></div>
  </div>
</div>`;
};

const parseDescription = (raw) => {
  const el = new DOMParser().parseFromString(
    `<div class="container">${raw}</div>`,
    "text/html"
  );
  const hasDescription = el.querySelector(".container .description");
  const text = hasDescription
    ? hasDescription.innerText.split("with")[1]
    : el.querySelector(".container").innerText.split("Ingredients")[0];
  return text;
};
